import { useQuery } from "@tanstack/react-query";
import { getCommunicationStatusCount } from "../services";
import type {
	CommunicationStatusCountFilters,
	CommunicationTabCounts,
} from "../types";

export const COMMUNICATION_STATUS_COUNT_QUERY_KEY =
	"tracking-communication-status-count";

export function useCommunicationStatusCount(
	filters: CommunicationStatusCountFilters
) {
	return useQuery<CommunicationTabCounts>({
		queryKey: [COMMUNICATION_STATUS_COUNT_QUERY_KEY, filters],
		queryFn: () => getCommunicationStatusCount(filters),
	});
}
